"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserComputeCss = void 0;
var BrowserComputeCss = /** @class */ (function () {
    function BrowserComputeCss(prop, value) {
        this.volatileElement = document.createElement('style-sandbox-element');
        this.volatileElement.style.setProperty(prop, value);
    }
    BrowserComputeCss.prototype.getLonghand = function (longhandProp) {
        var propertyValue = this.volatileElement.style.getPropertyValue(longhandProp);
        if (propertyValue.toLowerCase() === 'currentcolor') {
            // Workaround for Edge15
            return 'currentcolor';
        }
        return propertyValue;
    };
    return BrowserComputeCss;
}());
exports.BrowserComputeCss = BrowserComputeCss;
//# sourceMappingURL=browser-compute-css.js.map